import { setOneTrustGroups } from '../../force-app/main/default/staticresources/B2C_BackboneExtensions.js';
window.setOneTrustGroups = setOneTrustGroups;

import initHandlebarsHelpers from '../../force-app/main/default/staticresources/B2C_HandlebarsHelpers.js';
initHandlebarsHelpers();

import { B2C_UrlUtility } from '../../force-app/main/default/staticresources/B2C_UrlUtilities.js';
window.B2C_UrlUtility = B2C_UrlUtility;

import initJqueryPlugins from '../../force-app/main/default/staticresources/B2C_JqueryPlugins.js';
initJqueryPlugins();

import '../../force-app/main/default/staticresources/B2C_SliderWidgetJS.js';

import { B2C_ColorFilterUtility } from '../../force-app/main/default/staticresources/B2C_ColorFilterUtility.js';
window.B2C_ColorFilterUtility = B2C_ColorFilterUtility;

import { B2C_AddressAutocomplete } from '../../force-app/main/default/staticresources/B2C_GooglePlacesAutocomplete.js';
window.B2C_AddressAutocomplete = B2C_AddressAutocomplete;

import initRippleAnimation from '../../force-app/main/default/staticresources/B2C_RippleAnimation.js';
initRippleAnimation();
